import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { TokenService } from '../../authentication/token.service';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class RestHttpInterceptor implements HttpInterceptor {
  constructor(private token: TokenService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      /(^\/PosServer\/rest\/internal|\/PosServer\/rest\/manager|\/PosServer\/ReportServlet|\/reporting\/print-proxy\/)/.test(
        req.url
      )
    ) {
      return this.token.getToken$().pipe(
        switchMap(token => {
          const localEnv =
            window.location.hostname === 'localhost' ? '?local=true' : '';
          if (
            /^\/PosServer\/rest\/internal|\/PosServer\/rest\/manager/.test(
              req.url
            )
          ) {
            let headers = req.headers.set('X-Auth-Token', token);
            if (this.token.context) {
              headers = headers.set('X-Resto-Context', this.token.context);
            }
            const authReq = req.clone({
              headers,
              url: `${location.origin.replace('-web', '')}${req.url}${localEnv}`
            });
            return next.handle(authReq);
          }

          if (/\/PosServer\/ReportServlet/.test(req.url)) {
            const params =
              req.url.indexOf('token=') === -1
                ? req.params.append(
                    'token',
                    req.params.has('companyIds') ||
                      req.url.indexOf('companyIds=') > -1
                      ? this.token.adminToken
                      : token
                  )
                : req.params;
            let headers = req.headers;
            if (
              this.token.context &&
              !params.get('companyIds') &&
              req.url.indexOf('companyIds=') === -1 &&
              !req.headers.has('X-Resto-Context')
            ) {
              headers = headers.set('X-Resto-Context', this.token.context);
            }
            const authReq = req.clone({
              params: params,
              headers
            });
            return next.handle(authReq);
          }

          if (/\/reporting\/print-proxy\//.test(req.url)) {
            let headers = req.headers;
            if (this.token.context && !req.headers.has('X-Resto-Context')) {
              headers = headers.set('X-Resto-Context', this.token.context);
            }
            const authReq = req.clone({
              headers
            });
            return next.handle(authReq);
          }
          return next.handle(req);
        })
      );
    }
    return next.handle(req);
  }
}
